import { render, staticRenderFns } from "./ReceiverForm.vue?vue&type=template&id=5ea2a3c2"
import script from "./ReceiverForm.vue?vue&type=script&lang=ts"
export * from "./ReceiverForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports